import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawBrickedOffDoorIcon from "./RawBrickedOffDoorIcon.svg.jsx";

const BrickedOffDoorIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawBrickedOffDoorIcon} {...props} />;
});

export default BrickedOffDoorIcon;
